import React, { 
	//useRef, 
	useEffect,
	//useState 
} from "react";
import { connect } from "react-redux";
//import { CalciteNotice } from "@esri/calcite-components-react";
import DownloadDataBlock from "./DataForAddins/DownloadDataBlock";
import ReportBlock from "./DataForAddins/ReportBlock";


const DataForRegulatorsPanel = ({isMapLoading, arcgisMap}) => {

	
	useEffect(() => {
		
		
	}, [arcgisMap]);


	return (<>
	
			<DownloadDataBlock />
			<ReportBlock />
	</>);
}

const mapStateToProps = (state) => ({
	
});
// what actions are we allowed to use
const mapDispatchToProps = (dispatch) => ({
	
});

export default connect(mapStateToProps, mapDispatchToProps)(DataForRegulatorsPanel);
